class Slider {
  constructor(selector, options = {}) {
    this.slider = document.querySelector(selector);
    this.slides = this.slider.querySelectorAll('.slide');
    this.slideMax = this.slides.length;
    this.sliderPrev = this.slider.querySelector('.slider-prev');
    this.sliderNext = this.slider.querySelector('.slider-next');
    this.sliderController = this.slider.querySelector('.slider-controls');
    this.options = Object.assign({
      keyboard: false,
      pagination: false,
      clickable: false,
      labelSlider: 'Slider',
      labelPrev: 'Previous',
      labelNext: 'Next',
      labelSlide: 'Slide {index}',
      labelDot: 'Go to slide {index}',
      buttonPrev: 'Prev',
      buttonNext: 'Next'
    }, options);
    this.init();
  }
  init() {
    this.sliderPrev.disabled = true;
    this.currentSlideIndex = 0;
    if (this.options.pagination) this.createPagination();
    this.setupIntersectObserver();
    this.setupArrowNavigation();
    if (this.options.keyboard) this.setupKeyboardNavigation();
    this.addWaiAria();
    this.setupButtons();
    this.updateButtonStates();
  }
  addWaiAria() {
    this.slider.setAttribute('aria-label', this.options.labelSlider);
    this.slider.setAttribute('role', 'region');
    this.sliderPrev.setAttribute('aria-label', this.options.labelPrev);
    this.sliderNext.setAttribute('aria-label', this.options.labelNext);
    if (this.options.pagination) {
      const dots = this.slider.querySelectorAll('.dot');
      dots.forEach((dot, index) => {
        const dotLabel = this.options.labelDot.replace('{index}', (index + 1));
        dot.setAttribute('aria-label', dotLabel);
      });
    }
    this.slides.forEach((slide, index) => {
      const slideLabel = this.options.labelSlide.replace('{index}', (index + 1));
      slide.setAttribute('aria-label', slideLabel);
    });
  }
  setupButtons() {
    this.sliderPrev.innerHTML = this.options.buttonPrev;
    this.sliderNext.innerHTML = this.options.buttonNext;
  }
  createPagination() {
    this.sliderDots = document.createElement('div');
    this.sliderDots.classList.add('slider-dots');
    this.slides.forEach((slide, index) => {
      const dot = document.createElement('span');
      dot.classList.add('dot');
      dot.setAttribute('data-slide', index);
      if (index === 0) dot.classList.add('current');
      if (this.options.clickable) {
        this.sliderDots.setAttribute('data-clickable', true);
        dot.addEventListener('click', () => {
          this.goToSlide(index);
          this.updateButtonStates();
        });
      }
      this.sliderDots.appendChild(dot);
    });
    this.sliderController.appendChild(this.sliderDots);
  }
  setupIntersectObserver() {
    const options = { root: this.slider.querySelector('.slider-main'), rootMargin: '0px -50%', threshold: 0 };
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
    this.slides.forEach((slide) => this.observer.observe(slide));
  }
  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const currentIndex = Array.from(this.slides).indexOf(entry.target);
        if (currentIndex !== this.currentSlideIndex) {
          this.currentSlideIndex = currentIndex;
          this.updateButtonStates();
        }
      }
    });
  }
  activatePagination(targetSlide) {
    const newIndex = Array.from(this.slides).indexOf(targetSlide);
    this.slider.querySelector('.dot.current').classList.remove('current');
    this.slider.querySelector(`.dot[data-slide="${newIndex}"]`).classList.add('current');
  }
  setupArrowNavigation() {
    this.slider.addEventListener('click', (event) => {
      const target = event.target.closest('.slider-prev, .slider-next');
      if (target) {
        const direction = target.classList.contains('slider-prev') ? 'prev' : 'next';
        this.navigateSlides(direction);
      }
    });
  }
  navigateSlides(direction) {
    let newIndex;
    if (direction === 'prev') {
      this.currentSlideIndex = Math.max(0, this.currentSlideIndex - 1);
      newIndex = this.currentSlideIndex;
    } else {
      this.currentSlideIndex = Math.min(this.slideMax - 1, this.currentSlideIndex + 1);
      newIndex = this.currentSlideIndex;
    }
    this.goToSlide(newIndex);
    this.updateButtonStates();
  }
  goToSlide(index) {
    const targetSlide = this.slides[index];
    targetSlide.scrollIntoView({ behavior: 'smooth' });
    if (this.options.pagination) this.activatePagination(targetSlide);
  }
  updateButtonStates() {
    this.sliderPrev.disabled = this.currentSlideIndex === 0;
    this.sliderNext.disabled = this.currentSlideIndex === this.slideMax - 1;
  }
  setupKeyboardNavigation() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.navigateSlides('prev');
      else if (event.key === 'ArrowRight') this.navigateSlides('next');
    });
  }
}
